var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZippyarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "22px",
    viewBox: "0 0 24 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Result-Card",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Result-Card---Closed-(Reliant)",
    transform: "translate(-254.000000, -461.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7-Copy",
    transform: "translate(202.000000, 169.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(43.000000, 156.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(0.000000, 127.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "expand_more_black_24dp-copy",
    transform: "translate(9.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path1",
    opacity: 0.87,
    points: "24 24 0 24 0 0 24 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#1E428A",
    fillRule: "nonzero",
    points: "16.59 8.59 12 13.17 7.41 8.59 6 10 12 16 18 10"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZippyarrow);
export default __webpack_public_path__ + "static/media/zippyarrow.d676ffdf66b352719f2bb7fb191640eb.svg";
export { ForwardRef as ReactComponent };